


































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import { AppModule } from '@/store/modules/app';
import {
  TicketSetting,
  PlanSetting,
  IssuingRule,
  IssuingRuleId,
  IPlanSummaryData,
  IssuableDate,
  IssuableDateBaseDateTypeEnum,
  IDate,
  TimePeriod,
  TimePeriodUnitEnum,
  PlanSettingPrintSpecType,
  LanguageEnum,
  MogiriSettingPlanExtendedInfo,
} from '@/api/types';
import {
  listTicketSettings,
  IListPlanSettingsRequest,
  listPlanSettings,
  IGetPlanSettingRequest,
  getPlanSetting,
  IPutPlanSettingRequest,
  putPlanSetting,
  IListPlansRequest,
  listPlans,
} from '@/api/tickets';
import {
  formatApiError,
  compareString,
  stringToIDate,
  stringFromIDate,
  formatDate,
  stringToNumber,
  supportedMogiriSettingPlanLocaledExtendedInfoLangs,
} from '@/utils/index';
import { planToText, newDefaultIPutPlanSettingRequest } from '@/utils/tickets';
import { translateRouteTitle } from '@/utils/permission';

type ItemType = {
  text: string;
  value: string;
};

type WithIssuableDates = {
  issuableFromDates: string[];
  issuableFromOptDates: string[];
  issuableToDates: string[];
  issuableToOptDates: string[];
};

type WithIsActive = {
  isActive: boolean;
};

@Component({
  name: 'PlanSettingCreate',
  components: {
    MaterialCard,
  },
})
export default class extends Vue {
  private planTitle = '';
  private unitTitle = '';
  private loading = true;
  private valid = false;
  private editingPlanSetting: IPutPlanSettingRequest &
    WithIssuableDates &
    WithIsActive = {
    issuableFromDates: [],
    issuableFromOptDates: [],
    issuableToDates: [],
    issuableToOptDates: [],
  } as any;
  private hasBookingDetailBgcolor = false;
  private langItems: ItemType[] = [];
  private plansByPlanId: Map<string, IPlanSummaryData> = new Map();
  private planItems: ItemType[] = [];
  private fromDateMenus: boolean[] = [];
  private fromOptDateMenus: boolean[] = [];
  private toDateMenus: boolean[] = [];
  private toOptDateMenus: boolean[] = [];
  private redirectAfterCreate = true;
  private showRedirectAfterCreate = true;
  private dialog = false;
  private dialogConfirmHandler = this.resetDialog;
  private dialogTextTitle = '';
  private dialogTextFooter = '';
  private showCopyPlanSettings = false;
  private canCopyPlanSettings = false;
  private copyPlanSettingId = '';
  private planSettings: Map<string, PlanSetting> | null = null;
  private planSettingItems: ItemType[] = [];
  private enableMogiri = true;
  private tickets: TicketSetting[] = [];

  get ticketItems() {
    return this.tickets.map(ticket => ({
      text: ticket.title + '|' + ticket.planId + '|' + ticket.unitId,
      value: ticket.id,
    }));
  }

  get isDialogFullscreen() {
    return false && this.$vuetify.breakpoint.smAndDown;
  }

  get issuingRuleItems() {
    return Object.values(IssuingRuleId)
      .filter(
        r =>
          (r as IssuingRuleId) !== IssuingRuleId.UNKNOWN_RULE &&
          (r as IssuingRuleId) !==
            IssuingRuleId.MUST_ISSUE_AFTER_SPECIFIC_TICKET
      )
      .map(r => ({
        text: this.$t(`IssuingRuleId.${r}`),
        value: r as string,
      }));
  }

  get issuableDateBaseItems() {
    return Object.values(IssuableDateBaseDateTypeEnum)
      .filter(
        b =>
          (b as IssuableDateBaseDateTypeEnum) !==
          IssuableDateBaseDateTypeEnum.UNKNOWN_DATE
      )
      .map(b => ({
        text: this.$t(`IssuableDateBaseDateTypeEnum.${b}`),
        value: b as string,
      }));
  }

  get timePeriodUnitItems() {
    return Object.values(TimePeriodUnitEnum)
      .filter(u => (u as TimePeriodUnitEnum) !== TimePeriodUnitEnum.UNKNOWN)
      .map(u => ({
        text: this.$t(`TimePeriodUnitEnum.${u}`),
        value: u as string,
      }));
  }

  get printSpecTypeItems() {
    return Object.values(PlanSettingPrintSpecType).map(t => ({
      text: this.$t(`PlanSettingPrintSpecType.${t}`),
      value: t as string,
    }));
  }

  get canUpdatePlan() {
    return true;
  }

  get canUpdateUnit() {
    return true;
  }

  get canCreate() {
    return this.valid;
  }

  created() {
    this.fetchData();
    this.reset();
    this.loadLangItems();
  }

  private loadLangItems() {
    const langItems: ItemType[] = [];
    supportedMogiriSettingPlanLocaledExtendedInfoLangs.forEach(l => {
      langItems.push({
        value: l,
        text: this.$t(`LanguageEnum.${l}`) as string,
      });
    });
    this.langItems = langItems;
  }

  private async fetchThenLoadTicketSetting() {
    try {
      const res = await listTicketSettings({});
      this.tickets = res.tickets;
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Ticket setting'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private async fetchData(noLoading = false) {
    if (!noLoading) {
      this.loading = true;
      AppModule.StartProgress();
    }

    await Promise.all([
      this.fetchThenLoadPlans(),
      this.fetchThenLoadTicketSetting(),
    ]);

    if (!noLoading) {
      this.loading = false;
      AppModule.StopProgress();
    }
  }

  private async fetchThenLoadPlans() {
    const res = await listPlans({});
    this.plansByPlanId = new Map(res.plans.map(p => [p.planId, p]));

    const planItems: ItemType[] = [];
    this.plansByPlanId.forEach(p => {
      planItems.push({
        text: planToText(this.$i18n, p),
        value: p.planId,
      });
    });
    this.planItems = planItems.sort((a, b) => compareString(a.text, b.text));
  }

  private resetDialog() {
    this.dialog = false;
    this.dialogTextTitle = '';
    this.dialogTextFooter = '';
    this.showRedirectAfterCreate = true;
    this.showCopyPlanSettings = false;
    this.$nextTick(() => {
      this.dialogConfirmHandler = this.resetDialog;
    });
  }

  private showDialogForCreate() {
    this.dialogTextTitle = `${this.translateRouteTitle(
      this.$route.meta.title
    )}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.showRedirectAfterCreate = true;
    this.showCopyPlanSettings = false;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.createPlanSetting();
    };
    this.dialog = true;
  }

  private showDialogForReset() {
    this.dialogTextTitle = `${this.$t('Reset')}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.showRedirectAfterCreate = false;
    this.showCopyPlanSettings = false;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.reset();
    };
    this.dialog = true;
  }

  private async showDialogForCopy() {
    await this.fetchThenLoadPlanSettings();
    this.dialogTextTitle = `${this.$t('Copy from other {msg}', {
      msg: this.$t('Plan setting'),
    })}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.showRedirectAfterCreate = false;
    this.showCopyPlanSettings = true;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.copyPlanSetting();
    };
    this.dialog = true;
  }

  private async fetchThenLoadPlanSettings() {
    if (!this.planSettings) {
      try {
        const res = await listPlanSettings({});
        this.planSettings = new Map(res.plans.map(p => [p.id, p]));
        this.planSettingItems = res.plans.map(p => ({
          text: `${planToText(
            this.$i18n,
            this.plansByPlanId.get(p.planId)!
          )} (${p.id})`,
          value: p.id,
        }));
      } catch (err) {
        this.$toast.error(
          this.$t('Failed to {do} due to {err}', {
            do: (this.$t('Fetch {msg}', {
              msg: this.$t('Plan setting'),
            }) as string).toLowerCase(),
            err: formatApiError(this.$i18n, err),
          }) as string,
          {
            icon: 'mdi-alert',
          }
        );
      }
    }
  }

  private copyPlanSetting() {
    const copyPlanSetting = this.planSettings!.get(this.copyPlanSettingId)!;
    this.editingPlanSetting = {
      planId: '',
      issuingRules: copyPlanSetting.issuingRules,
      issuableFrom: copyPlanSetting.issuableFrom,
      issuableTo: copyPlanSetting.issuableTo,
      applyingRule: copyPlanSetting.applyingRule,
      printSpecs: copyPlanSetting.printSpecs || [],
      uiSetting: copyPlanSetting.uiSetting || {
        bookingDetailBgcolor: '',
      },
      isInactive: copyPlanSetting.isInactive,
      issuableFromDates: [],
      issuableFromOptDates: [],
      issuableToDates: [],
      issuableToOptDates: [],
      isActive: !copyPlanSetting.isInactive,
      mogiriSetting: copyPlanSetting.mogiriSetting,
    };
    this.enableMogiri = !!copyPlanSetting.mogiriSetting;
    const issuableFromDates: string[] = [];
    const issuableFromOptDates: string[] = [];
    const fromDateMenus: boolean[] = [];
    const fromOptDateMenus: boolean[] = [];
    this.editingPlanSetting.issuableFrom.forEach(f => {
      issuableFromDates.push(
        this.isRelativeFixedDate(f)
          ? stringFromIDate(f.relativeFixedDate!)!
          : this.isAbsoluteFixedDate(f)
          ? stringFromIDate(f.absoluteFixedDate!)!
          : ''
      );
      issuableFromOptDates.push(
        this.isRelativeFixedDate(f) && this.hasYearIncreamentBaseDate(f)
          ? stringFromIDate(f.yearIncreamentBaseDate!)!
          : ''
      );
      fromDateMenus.push(false);
      fromOptDateMenus.push(false);
    });
    this.editingPlanSetting.issuableFromDates = issuableFromDates;
    this.editingPlanSetting.issuableFromOptDates = issuableFromOptDates;
    this.fromDateMenus = fromDateMenus;
    this.fromOptDateMenus = fromOptDateMenus;
    const issuableToDates: string[] = [];
    const issuableToOptDates: string[] = [];
    const toDateMenus: boolean[] = [];
    const toOptDateMenus: boolean[] = [];
    this.editingPlanSetting.issuableTo.forEach(t => {
      issuableToDates.push(
        this.isRelativeFixedDate(t)
          ? stringFromIDate(t.relativeFixedDate!)!
          : this.isAbsoluteFixedDate(t)
          ? stringFromIDate(t.absoluteFixedDate!)!
          : ''
      );
      issuableToOptDates.push(
        this.isRelativeFixedDate(t) && this.hasYearIncreamentBaseDate(t)
          ? stringFromIDate(t.yearIncreamentBaseDate!)!
          : ''
      );
      toDateMenus.push(false);
      toOptDateMenus.push(false);
    });
    this.editingPlanSetting.issuableToDates = issuableToDates;
    this.editingPlanSetting.issuableToOptDates = issuableToOptDates;
    this.toDateMenus = toDateMenus;
    this.toOptDateMenus = toOptDateMenus;
    this.hasBookingDetailBgcolor = !!this.editingPlanSetting.uiSetting
      .bookingDetailBgcolor;

    if (!this.editingPlanSetting.mogiriSetting) {
      this.$set(this.editingPlanSetting, 'mogiriSetting', {
        bannerUrls: {
          details: '',
          valid: '',
          expired: '',
        },
        localedExtendedInfo: [],
      });
    }
  }

  private reset() {
    this.editingPlanSetting = newDefaultIPutPlanSettingRequest() as any;

    this.editingPlanSetting.issuableFromDates = [];
    this.editingPlanSetting.issuableFromOptDates = [];
    this.editingPlanSetting.issuableToDates = [];
    this.editingPlanSetting.issuableToOptDates = [];
    this.editingPlanSetting.isActive = !this.editingPlanSetting.isInactive;
    this.fromDateMenus = [];
    this.fromOptDateMenus = [];
    this.toDateMenus = [];
    this.toOptDateMenus = [];
    this.hasBookingDetailBgcolor = !!this.editingPlanSetting.uiSetting
      .bookingDetailBgcolor;
  }

  private async createPlanSetting() {
    this.loading = true;
    AppModule.StartProgress();

    try {
      const newPlanSetting = JSON.parse(
        JSON.stringify(this.editingPlanSetting)
      ) as IPutPlanSettingRequest;

      newPlanSetting.issuableFrom.forEach(i => {
        if (this.isRelativeFixedDate(i)) {
          delete i.period;
          delete i.absoluteFixedDate;
        } else if (this.isAbsoluteFixedDate(i)) {
          delete i.period;
          delete i.relativeFixedDate;
        } else {
          delete i.relativeFixedDate;
          delete i.absoluteFixedDate;
        }
      });
      newPlanSetting.issuableTo.forEach(i => {
        if (this.isRelativeFixedDate(i)) {
          delete i.period;
          delete i.absoluteFixedDate;
        } else if (this.isAbsoluteFixedDate(i)) {
          delete i.period;
          delete i.relativeFixedDate;
        } else {
          delete i.relativeFixedDate;
          delete i.absoluteFixedDate;
        }
      });
      if (!this.hasBookingDetailBgcolor) {
        newPlanSetting.uiSetting.bookingDetailBgcolor = '';
      }
      delete (newPlanSetting as any).issuableFromDates;
      delete (newPlanSetting as any).issuableFromOptDates;
      delete (newPlanSetting as any).issuableToDates;
      delete (newPlanSetting as any).issuableToOptDates;

      if (!this.enableMogiri) {
        (newPlanSetting.mogiriSetting as any) = null;
      }

      const req: IPutPlanSettingRequest = {
        planId: newPlanSetting.planId,
        issuingRules: newPlanSetting.issuingRules,
        issuableFrom: newPlanSetting.issuableFrom,
        issuableTo: newPlanSetting.issuableTo,
        applyingRule: newPlanSetting.applyingRule,
        printSpecs: newPlanSetting.printSpecs,
        uiSetting: newPlanSetting.uiSetting,
        isInactive: newPlanSetting.isInactive,
        mogiriSetting: newPlanSetting.mogiriSetting,
      };

      const res = await putPlanSetting(req);
      await this.postCreate(res.planSettingId);
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.translateRouteTitle(
            this.$route.meta.title
          ) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
      await this.postCreate();
    }

    AppModule.StopProgress();
    this.loading = false;
  }

  private async postCreate(planSettingId?: string) {
    if (this.redirectAfterCreate && planSettingId) {
      this.$nextTick(() => {
        this.$router.push(`/plansetting/${planSettingId}`);
      });
    } else {
      this.reset();
      await this.fetchData(true);

      if (planSettingId) {
        this.$toast.success(
          this.$t('Succeeded {do}', {
            do: (this.translateRouteTitle(
              this.$route.meta.title
            ) as string).toLowerCase(),
          }) as string,
          {
            icon: this.$route.meta.icon,
          }
        );
      }
    }
  }

  private getPlanText(planId: string) {
    return this.plansByPlanId.has(planId)
      ? planToText(this.$i18n, this.plansByPlanId.get(planId)!)
      : '';
  }

  private UpdateIssuingRule(rule: IssuingRule) {
    if (this.isLimitedIssuingTicket(rule) && !rule.limitedIssuing) {
      // @ts-ignore
      rule.limitedIssuing = {
        ticketIds: [],
        maxIssuableKindQuantity: 0,
      };
    }
  }

  private isCannotPartialIssue(rule: IssuingRule) {
    return (rule.id as IssuingRuleId) === IssuingRuleId.CANNOT_PARTIALY_ISSUE;
  }

  private isLimitedIssuingTicket(rule: IssuingRule) {
    return (rule.id as IssuingRuleId) === IssuingRuleId.LIMITED_ISSUING;
  }

  private addEditingIssuingRule() {
    this.editingPlanSetting.issuingRules.push({
      id: IssuingRuleId.CANNOT_PARTIALY_ISSUE,
    });
  }

  private removeEditingIssuingRule(issuingRuleIndex: number) {
    this.editingPlanSetting.issuingRules.splice(issuingRuleIndex, 1);
  }

  private addEditingLocaledExtendedInfo() {
    this.editingPlanSetting.mogiriSetting.localedExtendedInfo?.push({
      lang: LanguageEnum.ENGLISH,
      extendedInfoList: [
        {
          title: '',
          description: '',
        },
      ],
    });
  }

  private removeEditingLocaledExtendedInfo(index: number) {
    this.editingPlanSetting.mogiriSetting.localedExtendedInfo?.splice(index, 1);
  }

  private addEditingExtendedInfoList(
    extendedInfoList: MogiriSettingPlanExtendedInfo[]
  ) {
    extendedInfoList.push({
      title: '',
      description: '',
    });
  }

  private removeEditingExtendedInfoList(
    extendedInfoList: MogiriSettingPlanExtendedInfo[],
    index: number
  ) {
    extendedInfoList.splice(index, 1);
  }

  private isRelativeFixedDate(date: IssuableDate) {
    return (
      (date.base as IssuableDateBaseDateTypeEnum) ===
      IssuableDateBaseDateTypeEnum.RELATIVE_FIXED_DATE
    );
  }

  private isAbsoluteFixedDate(date: IssuableDate) {
    return (
      (date.base as IssuableDateBaseDateTypeEnum) ===
      IssuableDateBaseDateTypeEnum.ABSOLUTE_FIXED_DATE
    );
  }

  private hasYearIncreamentBaseDate(date: IssuableDate) {
    return !!date.yearIncreamentBaseDate;
  }

  private addEditingIssuableFrom() {
    this.editingPlanSetting.issuableFrom.push({
      base: IssuableDateBaseDateTypeEnum.RELATIVE_FIXED_DATE,
      period: undefined,
      relativeFixedDate: stringToIDate(formatDate(new Date()))!,
    });
    this.editingPlanSetting.issuableFromDates.push(formatDate(new Date())!);
    this.editingPlanSetting.issuableFromOptDates.push('');
    this.fromDateMenus.push(false);
    this.fromOptDateMenus.push(false);
  }

  private removeEditingIssuableFrom(issuableFromIndex: number) {
    this.editingPlanSetting.issuableFrom.splice(issuableFromIndex, 1);
    this.editingPlanSetting.issuableFromDates.splice(issuableFromIndex, 1);
    this.editingPlanSetting.issuableFromOptDates.splice(issuableFromIndex, 1);
    this.fromDateMenus.splice(issuableFromIndex, 1);
    this.fromOptDateMenus.splice(issuableFromIndex, 1);
  }

  private handleIssuableFromRelativeFixedDateInput(
    date: string,
    issuableFromIndex: number
  ) {
    this.editingPlanSetting.issuableFrom[
      issuableFromIndex
    ].relativeFixedDate = stringToIDate(date)!;

    this.fromDateMenus[issuableFromIndex] = false;
  }

  private handleIssuableFromAbsoluteFixedDateInput(
    date: string,
    issuableFromIndex: number
  ) {
    this.editingPlanSetting.issuableFrom[
      issuableFromIndex
    ].absoluteFixedDate = stringToIDate(date)!;

    this.fromDateMenus[issuableFromIndex] = false;
  }

  private handleIssuableFromYearIncreamentBaseDateInput(
    date: string,
    issuableFromIndex: number
  ) {
    this.editingPlanSetting.issuableFrom[
      issuableFromIndex
    ].yearIncreamentBaseDate = stringToIDate(date)!;

    this.fromOptDateMenus[issuableFromIndex] = false;
  }

  private handleIssuableFromBaseInput(
    base: IssuableDateBaseDateTypeEnum,
    issuableFromIndex: number
  ) {
    if (
      (base as IssuableDateBaseDateTypeEnum) !==
        IssuableDateBaseDateTypeEnum.RELATIVE_FIXED_DATE &&
      !this.editingPlanSetting.issuableFrom[issuableFromIndex].period
    ) {
      this.editingPlanSetting.issuableFrom[issuableFromIndex].period = {
        count: 1,
        unit: TimePeriodUnitEnum.DAY,
      };
    }
  }

  private addEditingIssuableTo() {
    this.editingPlanSetting.issuableTo.push({
      base: IssuableDateBaseDateTypeEnum.RELATIVE_FIXED_DATE,
      period: undefined,
      relativeFixedDate: stringToIDate(formatDate(new Date()))!,
    });
    this.editingPlanSetting.issuableToDates.push(formatDate(new Date())!);
    this.editingPlanSetting.issuableToOptDates.push('');
    this.toDateMenus.push(false);
    this.toOptDateMenus.push(false);
  }

  private removeEditingIssuableTo(issuableToIndex: number) {
    this.editingPlanSetting.issuableTo.splice(issuableToIndex, 1);
    this.editingPlanSetting.issuableToDates.splice(issuableToIndex, 1);
    this.editingPlanSetting.issuableToOptDates.splice(issuableToIndex, 1);
    this.toDateMenus.splice(issuableToIndex, 1);
    this.toOptDateMenus.splice(issuableToIndex, 1);
  }

  private handleIssuableToRelativeFixedDateInput(
    date: string,
    issuableToIndex: number
  ) {
    this.editingPlanSetting.issuableTo[
      issuableToIndex
    ].relativeFixedDate = stringToIDate(date)!;

    this.toDateMenus[issuableToIndex] = false;
  }

  private handleIssuableToAbsoluteFixedDateInput(
    date: string,
    issuableToIndex: number
  ) {
    this.editingPlanSetting.issuableTo[
      issuableToIndex
    ].absoluteFixedDate = stringToIDate(date)!;

    this.toDateMenus[issuableToIndex] = false;
  }

  private handleIssuableToYearIncreamentBaseDateInput(
    date: string,
    issuableToIndex: number
  ) {
    this.editingPlanSetting.issuableTo[
      issuableToIndex
    ].yearIncreamentBaseDate = stringToIDate(date)!;

    this.toOptDateMenus[issuableToIndex] = false;
  }

  private handleIssuableToBaseInput(
    base: IssuableDateBaseDateTypeEnum,
    issuableToIndex: number
  ) {
    if (
      (base as IssuableDateBaseDateTypeEnum) !==
        IssuableDateBaseDateTypeEnum.RELATIVE_FIXED_DATE &&
      !this.editingPlanSetting.issuableTo[issuableToIndex].period
    ) {
      this.editingPlanSetting.issuableTo[issuableToIndex].period = {
        count: 1,
        unit: TimePeriodUnitEnum.DAY,
      };
    }
  }

  private addEditingPrintSpec() {
    this.editingPlanSetting.printSpecs.push({
      type: PlanSettingPrintSpecType.NONE,
      autoPrint: false,
    });
  }

  private removeEditingPrintSpec(printSpecIndex: number) {
    this.editingPlanSetting.printSpecs.splice(printSpecIndex, 1);
  }

  private getFixedDateText(fixedDate?: IDate) {
    return fixedDate ? stringFromIDate(fixedDate)!.slice(5) : '';
  }

  private getFixedDateWithYearText(fixedDate?: IDate) {
    return fixedDate ? stringFromIDate(fixedDate)! : '';
  }

  private getPeriodText(period?: TimePeriod) {
    return period
      ? `${period.count} ${this.$t(
          'TimePeriodUnitEnum.' + (period.unit as string)
        )}`
      : '';
  }

  private stringIsNumber(v?: string) {
    return v !== void 0 && !isNaN(stringToNumber(v));
  }

  private getRequiredRules(
    msg: any,
    exception: (v: any) => boolean = () => false
  ) {
    return [
      (v: string) =>
        exception(v) ||
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$te(msg) ? this.$t(msg) : msg,
        }) as string),
    ];
  }

  private getMinRules(
    msg: string,
    min?: number,
    exception: (v: any, min: any) => boolean = () => false
  ) {
    return [
      (v: number) =>
        exception(v, min) ||
        v >= min! ||
        (this.$t('{msg} must be equal or greater than {num}', {
          msg: this.$t(msg),
          num: min,
        }) as string),
    ];
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
